var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"base-button",class:[{ block: _vm.block }, { disable: _vm.disable }, { plain: _vm.plain }, _vm.size],attrs:{"type":"button"},on:{"click":_vm.clickEvent}},[_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }